(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-builder"] && !Shopify.designMode) return;
  try {
    const updateBundleBuilder = (builder, size) => {
    if (!Number.isInteger(size) || size < 1) return;

    builder.dataset.bundleSize = String(size);
    builder.querySelectorAll('[data-bundle-field]').forEach((field) => {
      const itemNumber = Number.parseInt(field.dataset.itemNumber, 10);
      const select = field.querySelector('select');
      const active = itemNumber <= size;

      field.hidden = !active;
      if (select) {
        select.disabled = !active;
        select.required = active;
        select.setAttribute('aria-required', active ? 'true' : 'false');
      }
    });

    builder.querySelectorAll('[data-tier-min]').forEach((tier) => {
      const minimum = Number.parseInt(tier.dataset.tierMin, 10);
      const maximum = Number.parseInt(tier.dataset.tierMax, 10);
      tier.classList.toggle('is-active', size >= minimum && size <= maximum);
    });

    const status = builder.querySelector('[data-bundle-status]');
    const progress = builder.querySelector('[data-bundle-progress]');
    let statusText = builder.dataset.statusBogeys;
    let progressText = builder.dataset.progressDoubleMany?.replace('__COUNT__', String(8 - size));

    if (size === 7) {
      progressText = builder.dataset.progressDoubleOne;
    } else if (size >= 8 && size <= 11) {
      statusText = builder.dataset.statusDouble;
      progressText = size === 11
        ? builder.dataset.progressTripleOne
        : builder.dataset.progressTripleMany?.replace('__COUNT__', String(12 - size));
    } else if (size >= 12 && size <= 22) {
      statusText = builder.dataset.statusTriple;
      progressText = size === 22
        ? builder.dataset.progressBoatloadTwo
        : builder.dataset.progressBoatloadMany?.replace('__COUNT__', String(24 - size));
    } else if (size === 24) {
      statusText = builder.dataset.statusBoatload;
      progressText = builder.dataset.progressUltimate;
    }

    if (status) status.textContent = statusText || '';
    if (progress) progress.textContent = progressText || '';
  };

  document.querySelectorAll('[data-bundle-builder]').forEach((builder) => {
    updateBundleBuilder(builder, Number.parseInt(builder.dataset.bundleSize, 10));
  });

  document.addEventListener('variant:update', (event) => {
    const variant = event.detail?.resource;
    const productId = String(event.detail?.data?.productId || '');
    const size = Number.parseInt(variant?.title || '', 10);

    document.querySelectorAll('[data-bundle-builder][data-dynamic-bundle="true"]').forEach((builder) => {
      if (builder.dataset.productId === productId) updateBundleBuilder(builder, size);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
